import { request } from './api';

export function pushSupport() {
  if (!window.isSecureContext || !('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window))
    return 'Notifications aren’t available in this browser. On iPhone, add this app to your Home Screen first.';
  return '';
}
export async function getPushState() {
  if (pushSupport()) return false;
  const reg = await navigator.serviceWorker.getRegistration();
  return Boolean(await reg?.pushManager.getSubscription());
}
export async function enablePush() {
  if (pushSupport()) throw new Error(pushSupport());
  // Permission must be requested directly inside a user gesture, including Safari.
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Notifications are blocked. Allow them in your browser’s site settings.');
  const keyData = await request('/push/vapid-public-key');
  if (typeof keyData?.publicKey !== 'string' || !keyData.publicKey) throw new Error('Notification setup is unavailable. Please try again later.');
  await navigator.serviceWorker.register('/sw.js');
  const reg = await navigator.serviceWorker.ready;
  const value = keyData.publicKey.replace(/-/g, '+').replace(/_/g, '/');
  const key = Uint8Array.from(atob(value.padEnd(Math.ceil(value.length / 4) * 4, '=')), c => c.charCodeAt(0));
  const existing = await reg.pushManager.getSubscription();
  const sub = existing || await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
  const json = sub.toJSON();
  try {
    await request('/push/subscribe', { method: 'POST', body: {
      subscription: { endpoint: json.endpoint, keys: json.keys }, tz_offset_minutes: -new Date().getTimezoneOffset(),
    } });
  } catch (e) { if (!existing) await sub.unsubscribe(); throw e; }
  return true;
}
export async function disablePush() {
  if (pushSupport()) return;
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = await reg?.pushManager.getSubscription();
  if (!sub) return;
  try { await request('/push/unsubscribe', { method: 'POST', body: { endpoint: sub.endpoint } }); }
  finally { await sub.unsubscribe(); }
}